import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeleteDocument(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const deleteDocument = (documentId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`documents/${documentId}/`);
  };

  return useMutation(deleteDocument, {
    onSuccess: () => {
      queryClient.removeQueries(['documents']);
    },
  });
}
